const ACTIONS = {
    JOIN: 'join',
    JOINED: 'joined',
    DISCONNECTED: 'disconnected',
    CHANGE: 'change',
    SYNC: 'sync ',
    LEAVE: 'leave'
}
module.exports = ACTIONS;